import React, { useEffect, useState } from "react";
import CustomButton from "./customButton";
import { Col, Row, Spin, message } from "antd";
import { IoIosArrowForward } from "react-icons/io";
import axios from "axios";
import { baseUrl } from "../utills";
import { green } from "../constants/colors";
// import SellItForMeForm from "./sellItForMeForm";
import { useBikeInfo } from "../context/BikeInfoContext";

const CarInfoSellItForMe = ({ setCarInfoModal,setOpenModal }) => {
  const token = localStorage.getItem("access_token");
  const [bikeMake, setBikeMake] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedId2, setSelectedId2] = useState(null);
  const [bikeModels, setBikeModels] = useState([]);
  const [bikeInfo, setBikeInfo] = useBikeInfo();
  // console.log("bikeInfo...", bikeInfo);
  const [selectedYear, setSelectedYear] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();

  const startYear = 2024;
  const endYear = 1940;
  const years = [];

  for (let year = startYear; year >= endYear; year--) {
    years.push(year);
  }
  const fetchMake = async (year) => {
    try {
      const res = await axios.get(
        baseUrl + `bike_makers_by_year/?release_year=${year}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res?.status === 200) {
        console.log("bike_makers:", res);

        setBikeMake(res?.data?.data?.bike_makers || []);
      }
    } catch (error) {
      console.error("error:", error);

      setBikeMake([]);
    }
  };
  // useEffect(() => {
  //   fetchMake();
  // }, []);
  const fetchModel = async (item) => {
    console.log("item::", item);

    setBikeInfo((prevInfo) => ({
      // ...prevInfo,
      make: item?.bike_maker,
      bike_maker_id: item?.id,
    }));
    setSelectedId(item?.id);
    try {
      const res = await axios.get(
        baseUrl + `bike-models/view/?bike_maker_id=${item?.id}`,

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("bikeModels:", res);

      setBikeModels(res?.data || []);
    } catch (error) {
      console.error("error:", error);
    }
  };

  const clickModel = (item) => {
    console.log("item:", item);
    setOpenModal(false);

    setBikeInfo((prevInfo) => ({
      ...prevInfo,
      model: item?.model_name,
      model_id: item?.id,
    }));
  };

  const submit = async () => {
    setBikeModels([]);
    setSelectedId(null);
    setSelectedId2(null);
    setOpenModal(false);
  };

  return (
    <>
      {contextHolder}
      <div className="">
        <div className="grid grid-cols-3">
          <div>
            <p className="text-[14px] md:text-[18px] font-[500] ps-2 md:ps-4 border-b border-r border-[#e0e0e0] py-4">
              Year
            </p>
          </div>
          <div>
            <p className="text-[14px] md:text-[18px] font-[500] ps-2 md:ps-4 border-b border-r border-[#e0e0e0] py-4">
              MAKE
            </p>
          </div>
          <div>
            <p className="text-[14px] md:text-[18px] font-[500] ps-2 md:ps-4 border-r border-b border-[#e0e0e0] py-4">
              MODEL
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-3">
        <div>
          <div className="py-4 border-[#e0e0e0] border-r border-b px-2">
            <div className="overflow overflow-y-auto h-[400px] px-2">
              {years?.map((year) => (
                <div
                  key={year}
                  onClick={() => fetchMake(year)}
                  className={`flex justify-between items-center mt-2 cursor-pointer hover:text-customGreen ${
                    selectedYear === year ? "text-customGreen" : ""
                  }`}
                >
                  <p className="font-[400]">{year}</p>
                  <IoIosArrowForward />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div>
          <Spin spinning={false}>
            <div className="py-4 border-r border-b border-[#e0e0e0] px-2">
              <div className="overflow overflow-y-auto h-[400px] px-2">
                {bikeMake?.map((item, id) => (
                  <div
                    key={item?.id}
                    onClick={() => fetchModel(item)}
                    className={`flex justify-between items-center mt-2 cursor-pointer hover:text-customGreen ${
                      selectedId === item?.id ? "text-customGreen" : ""
                    }`}
                  >
                    <p className="font-[400]">{item?.bike_maker}</p>
                    <IoIosArrowForward />
                  </div>
                ))}
              </div>
            </div>
          </Spin>
        </div>
        <div>
          <div className="py-4 border-r border-b border-[#e0e0e0] px-2">
            <div className="overflow overflow-y-auto h-[400px] px-2">
              {bikeModels?.map((item) => (
                <div
                  key={item?.id}
                  onClick={() => clickModel(item, item?.car_maker_id, item?.id)}
                  className={`flex justify-between items-center mt-2 cursor-pointer hover:text-customGreen ${
                    selectedId2 === item?.id ? "text-customGreen" : ""
                  }`}
                >
                  <p className="font-[400]">{item?.model_name}</p>
                  <IoIosArrowForward />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="w-[150px] m-auto mt-4 mb-4">
        <CustomButton
          style={{ background: green, borderRadius: "4px", padding: "10px" }}
          onClick={submit}
        >
          Done
        </CustomButton>
      </div>
    </>
  );
};

export default CarInfoSellItForMe;
